/**
 * Stav behu AI asistenta v chate — `GET /assistant/chats/:id` pole `run`. Odpoveď beží na serveri
 * nezávisle od spojenia (appka na pozadí, zatvorená karta); klient po návrate podľa stavu ukáže
 * „pracuje", kartu e-mailu, vykoná nástroj telefónu alebo chybu.
 */
export type AssistantRunState =
  | { status: 'idle' }
  | { status: 'running' }
  | { status: 'interrupted' }
  | { status: 'waiting_email'; toolUseId: string; draft: Record<string, unknown> }
  | { status: 'waiting_device'; toolUseId: string; name: string; input: Record<string, unknown> }

/** SSE `error.code`: chat má rozbehnutú odpoveď, požiadavka (nová správa aj pokračovanie po e-maile či nástroji telefónu) sa neprijala; kredit sa nestiahol. */
export const ASSISTANT_CHAT_BUSY = 'CHAT_BUSY'

/** Ako často sa klient pýta na stav odpovede, ktorá beží bez spojenia. */
export const ASSISTANT_RUN_POLL_MS = 3_000

export const ASSISTANT_RUN_TEXT = {
  running: 'Asistent pracuje…',
  interrupted: 'Odpoveď sa nedokončila, skúste znova.',
  /** Admin nevie vykonať nástroje telefónu — chat začatý v mobile tam čaká. */
  waitingDeviceElsewhere: 'Asistent potrebuje kontakty z telefónu — pokračujte v mobilnej aplikácii.',
} as const
